import { Injectable } from '@angular/core';
import { AppState } from '../store/app.state';

@Injectable({
  providedIn: 'root',
})
export class QueryParamsService {
  constructor(public appState: AppState) {}

  public initialize(): void {
    // Save QueryParams before any redirect to use them in analytics.service
    const params = new URLSearchParams(window.location.search);
    const queryParams: Record<string, string> = Object.fromEntries([...params.entries()]);
    if (queryParams) {
      this.saveQueryParams(queryParams);
    }
  }

  private saveQueryParams(queryParams: Record<string, string>): void {
    void this.appState.set({ queryParams: queryParams });
  }
}
